namespace TabAurous.Purchase {
    export interface ApprovalInItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        LedgerName?: string;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        GroupId?: number;
        RoutingId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        CollectionId?: number;
        MetalId?: number;
        AttributeId?: number;
        HSN?: string;
        TaxCode?: string;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        DesignId?: number;
        DesignCode?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        BOMDetails?: ApprovalInBOMRow[];
        LaborDetails?: ApprovalInLaborRow[];
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        CategoryCode?: string;
        Attribute?: string;
        CalcUnitId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        ProductSizeCode?: string;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        DiscountPer?: number;
        VoucherNo?: string;
        TransDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        MFAmount?: number;
        MF?: number;
        HUID?: string;
        FancyCharges?: number;
        OtherCharges?: number;
        StampId?: number;
        StampCode?: string;
        ExportPieces?: number;
        DeptName?: string;
        CompanyCode?: string;
        StoneRate?: number;
        OtherRate?: number;
        PurchaseVoucher?: string;
        PurchasePieces?: number;
        PurchaseWeight?: number;
        SalesVoucher?: string;
        SalesPieces?: number;
        SalesWeight?: number;
        RemainingPieces?: number;
        RemainingWeight?: number;
    }

    export namespace ApprovalInItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Purchase.ApprovalInItems';
        export const deletePermission = 'Purchase:Apprroval:Delete';
        export const insertPermission = 'Purchase:Apprroval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Purchase:Apprroval:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            GroupId = "GroupId",
            RoutingId = "RoutingId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            SuperTypeCode = "SuperTypeCode",
            CollectionId = "CollectionId",
            MetalId = "MetalId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            TaxCode = "TaxCode",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            CategoryCode = "CategoryCode",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            ProductSizeCode = "ProductSizeCode",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            DiscountPer = "DiscountPer",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            MFAmount = "MFAmount",
            MF = "MF",
            HUID = "HUID",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            StampId = "StampId",
            StampCode = "StampCode",
            ExportPieces = "ExportPieces",
            DeptName = "DeptName",
            CompanyCode = "CompanyCode",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            PurchaseVoucher = "PurchaseVoucher",
            PurchasePieces = "PurchasePieces",
            PurchaseWeight = "PurchaseWeight",
            SalesVoucher = "SalesVoucher",
            SalesPieces = "SalesPieces",
            SalesWeight = "SalesWeight",
            RemainingPieces = "RemainingPieces",
            RemainingWeight = "RemainingWeight"
        }
    }
}
